import { combineReducers } from 'redux';
import { generators } from './generators';

export const store = combineReducers({
  pullRequests: combineReducers({
    pages: generators.pullRequests.pages.store(),
  }),
  commentPosting: combineReducers({
    toggle: generators.commentPosting.toggle.store(),
  }),
  staticFilters: combineReducers({
    pages: generators.staticFilters.pages.store(),
    create: generators.staticFilters.create.store(),
    delete: generators.staticFilters.delete.store(),
    lastDeleted: (state = null, action) => {
      switch (action.type) {
        case 'PROJECTS/STATIC_FILTERS/CLEAR_TOAST':
          return null;
        case 'PROJECTS/STATIC_FILTERS/SHOW_TOAST':
          return action.filter;
        default:
          return state;
      }
    },
  }),
});
